import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    targetUrl: String,
    product: { type: String, default: "academics" },
    userTwrn: String
  }

  async redirect(event) {
    event.preventDefault()

    if (!this.targetUrlValue) {
      alert("This feature is not available for your organization.")
      return
    }

    try {
      const token = await this.getAxleToken()
      if (token) {
        let url = `${this.targetUrlValue}?token=${token}`
        // Deep link to profile if user TWRN is available
        if (this.userTwrnValue) {
          const encodedTwrn = btoa(this.userTwrnValue)
          url += `&redirect=${encodeURIComponent(`/profiles/${encodedTwrn}`)}&redirect_with_token=true`
        }
        console.log(url)
        window.open(url, "_blank")
      } else {
        alert("Unable to authenticate. Please try again or contact support.")
      }
    } catch (error) {
      console.error("Failed to retrieve authentication token:", error)
      alert("Unable to authenticate. Please try again or contact support.")
    }
  }

  async getAxleToken() {
    const csrf = document.querySelector("meta[name='csrf-token']").getAttribute("content")
    const response = await fetch("/auth/axle/token", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrf
      },
      body: JSON.stringify({ product: this.productValue })
    })
    const data = await response.json()
    return data.token
  }
}

